import TestingScreen from './TestingScreen';

export default TestingScreen;
